module.exports = "/assets/data/e9fa36b208ef46eeafc3af0f708cbd6b-CH3.data.json";